import { Add } from "shared/components/Add";
import Layout from "../../components/mainPage/Layout";
import dispatchImg from "../../images/imagePopup/editor/blank.png"
import manufactureImg from "../../images/manufacture.png"
import { ImageContainer } from "shared/components/ImageContainer";

export const Page = () => {
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <h1 className="article-title">
            Диспетчерское управление электросетями
          </h1>

          <h2 className="section-title">
            SCADA NPT Expert+ для интеллектуального диспетчерского управления
            электросетями
          </h2>
          <p className="article-lead">
            Современные энергосети требуют комплексного управления,
            обеспечивающего надежность, эффективность и быстрое восстановление
            после аварий. SCADA NPT Expert+ c расширенными функциями DMS, OMS,
            EMS и FLISR – это интеллектуальная платформа для диспетчеризации,
            анализа и оптимизации работы распределительных и магистральных
            сетей.
          </p>

          <h2 className="section-title">Ключевые модули и функции системы:</h2>

          <div className="quote-box-list">
            <div className="quote-box">
              <h3 className="feature-title">
                1. Диспетчерское управление в реальном времени (SCADA + DMS)
              </h3>
              <ul className="feature-list">
                <li>
                  Мониторинг состояния сети (напряжение, токи, мощности, cos φ)
                </li>
                <li>
                  Управление коммутационными аппаратами (дистанционное
                  переключение)
                </li>
                <li>
                  Визуализация топологии сети с отображением режимов работы
                </li>
                <li>
                  Построение модели сети в соответствии с серией стандартов CIM
                  (Common Information Model)
                </li>
                <li>Географическая привязка элементов сети к местности</li>
              </ul>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">
                2. Аварийное управление (OMS + FLISR)
              </h3>
              <ul className="feature-list">
                <li>Автоматическое определение места повреждения (ОМП)</li>
                <li>
                  Функции самовосстановления (FLISR – Fault Location, Isolation,
                  Service Restoration)
                </li>
                <li>
                  Формирование оптимальных схем переключений для минимизации
                  времени простоя
                </li>
              </ul>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">
                3. Расчетные и аналитические модули (EMS)
              </h3>
              <ul className="feature-list">
                <li>Расчет установившихся и переходных режимов</li>
                <li>
                  Прогнозирование токов короткого замыкания (КЗ) для настройки
                  защит
                </li>
                <li>
                  Оценивание состояния сети (State Estimation) – устранение
                  противоречий в данных телеметрии
                </li>
                <li>
                  Анализ надежности (SAIDI, SAIFI и др.) и оценка качества
                  электроснабжения
                </li>
              </ul>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">4. Оптимизация работы сети</h3>
              <ul className="feature-list">
                <li>Расчет потерь и перетоков мощности</li>
                <li>
                  Поддержка Smart Grid (интеграция с DER, VPP, системами
                  накопления энергии)
                </li>
                <li>
                  Автоматическое перераспределение нагрузки
                </li>
                <li>
                  Групповое управление выключателями присоединений 6-20 кВ,
                  задействованных в графиках временного отключения потребителей
                </li>
              </ul>
            </div>
          </div>

          <h2 className="section-title">
            Преимущества внедрения SCADA NPT Expert+:
          </h2>
          <ul className="benefits-list">
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Повышение надежности </strong> – сокращение времени
              ликвидации аварий на 30-50%
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Снижение потерь </strong> – оптимизация режимов работы
              сети
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Умная аналитика</strong> – прогнозирование рисков и
              планирование модернизации
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Соответствие современным стандартам</strong> - CIM (ГОСТ Р 58651)
            </li>
          </ul>
          {/* <div className="cta-block">
            <p className="cta-text">
              <strong>
                Обеспечьте свою сеть передовыми инструментами управления –
                повысьте эффективность и снизьте операционные затраты!
              </strong>
            </p>
          </div> */}

          <ImageContainer
            src={dispatchImg}
            alt={'SCADA NPT Expert выполняет переключения на уровне РЭС'}
            caption={'SCADA NPT Expert выполняет переключения на уровне РЭС'}
          />    

          <Add
            text={<div style={{ fontSize: '2rem' }}>Обеспечьте свою сеть передовыми инструментами управления!</div>}
            description={<div style={{ fontSize: '1.3rem' }}>Повысьте эффективность и снизьте операционные затраты!</div>}
            image={manufactureImg}
          />
        </div>
      </div>
    </Layout>
  );
};

export const meta = {
  title: 'Диспетчерское управление электросетями',
  description: 'SCADA NPT Expert+ для интеллектуального диспетчерского управления электросетями'
}